import axios from 'axios'
let instance = axios.create();
import store from '@/store'
import { showToast } from 'vant'
// 判断是否是微信内打开的方法
const isWechat = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
};

const generateRandomNumber = function(num) {
	let chars = '123456789';
	let code = '';
	for (let i = 0; i < 6; i++) {
		let rd = Math.floor(Math.random() * 10);
		if (rd == 9) {
			rd = 8;
		}
		code += chars.charAt(rd);
	}

	return code;
}
// 根据环境变量判断正式环境还是测试环境
const isProd = process.env.NODE_ENV === 'production';
instance.defaults.baseURL = isProd ? 'https://youthpartner.voc.com.cn' : 'http://172.31.32.25:8009';
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    let nonce = generateRandomNumber(6)
    // console.log('request token:',store.state.token)
    config.headers = { 
        ...config.headers,
        'token':store.state.token
    }
    if(config.method == 'get'){
        config.params = {...config.params,nonce}
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    if(response.data.code == 1){
        return response
    }else{
        if(response.data.code == -1){
            store.commit('clearToken')
        }
        showToast({
            message:response.data.msg,
            duration:1000
        })
        return false
    }
    // 对响应数据做点什么  
}, function (error) {
    // 对响应错误做点什么
    console.log('--- 401 res error response ---')
    console.log(error)
    return Promise.reject(error)
})
export default instance